import MainContent from 'components/MainContent';
import Footer from 'components/Footer';
import { WebFrameHeader } from 'components/WebFrameHeader/WebFrameHeader';
import { Sidebar } from 'semantic-ui-react';
import { NavigationItemDto } from 'types/types';
import ErrorPage from 'components/ErrorPage';
import { useTranslation } from 'react-i18next';

interface WebframePageProps {
  handleHelpSectionSidebar: (val: boolean) => void;
  handleUserProfileSettingsSidebar: (val: boolean) => void;
  handleNotificationSidebar: (val: boolean) => void;
  selectedFiltersChanged: (selectedFilters: string[]) => void;
  filters: NavigationItemDto[];
  filterNames: string[];
  hasUnreadNotifications: boolean;
  errorInQueryParams: boolean;
}

export const WebframePage = (props: WebframePageProps) => {
  const { t } = useTranslation();
  return (
    <>
      <WebFrameHeader
        toggleHelpSectionSidebar={() => props.handleHelpSectionSidebar(true)}
        toggleUserProfileSettingsSidebar={() => props.handleUserProfileSettingsSidebar(true)}
        toggleNotificationSidebar={() => props.handleNotificationSidebar(true)}
        selectedFiltersChanged={props.selectedFiltersChanged}
        filters={props.filters}
        filterNames={props.filterNames}
        hasUnreadNotifications={props.hasUnreadNotifications}
      />
      <Sidebar.Pushable>
        <Sidebar.Pusher>
          <WebFrameHeader
            sidebar
            toggleHelpSectionSidebar={() => props.handleHelpSectionSidebar(true)}
            toggleUserProfileSettingsSidebar={() => props.handleUserProfileSettingsSidebar(true)}
            toggleNotificationSidebar={() => props.handleNotificationSidebar(true)}
            selectedFiltersChanged={props.selectedFiltersChanged}
            filters={props.filters}
            filterNames={props.filterNames}
            hasUnreadNotifications={props.hasUnreadNotifications}
          />
          {props.errorInQueryParams ? (
            <ErrorPage
              navigateToRootUrl={true}
              headerText={t('NoPermission')}
              bodyText={t('ErrorMessageForIncorrectURL')}
            />
          ) : (
            <MainContent />
          )}
          <Footer />
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </>
  );
};
